module.exports = __webpack_public_path__ + "static/16-32f0c8a57fc1bb52285d9f5659a5bca1.webp";